import React, { useEffect, useState } from 'react';
import { Bandage } from 'lucide-react';

const SplashScreen = ({ onFinish }) => {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    // Commence à fade après 1.5 secondes
    const timer = setTimeout(() => {
      setFade(true);
    }, 1500);

    // Termine complètement après 2 secondes
    const finishTimer = setTimeout(() => {
      if (onFinish) onFinish();
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 transition-opacity duration-500 ${
        fade ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="text-center">
        {/* Logo Sparadrap animé */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            {/* Effet de lueur */}
            <div className="absolute inset-0 animate-pulse">
              <Bandage className="h-24 w-24 text-blue-400 opacity-20 blur-xl" />
            </div>
            {/* Sparadrap principal */}
            <Bandage className="h-24 w-24 text-white animate-bounce" style={{ animationDuration: '2s' }} />
          </div>
        </div>

        {/* Nom de l'application */}
        <h1 className="text-4xl font-bold text-white mb-2 tracking-tight">
          AUTO-RÉPUTATION
        </h1>

        {/* Baseline subtile */}
        <p className="text-blue-200 text-sm font-light tracking-wider">
          Service confidentiel de gestion d&apos;e-réputation
        </p>

        {/* Barre de chargement animée */}
        <div className="mt-8 mx-auto w-48 h-1 bg-blue-950 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-blue-400 to-white animate-loading rounded-full"></div>
        </div>
      </div>

      <style>{`
        @keyframes loading {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
        .animate-loading {
          animation: loading 1.5s ease-in-out forwards;
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
